// The three roles, client side — the same three values the server defines in
// `constants/roles.js`, and nothing more.
//
// ⚠ NOTHING HERE ENFORCES ANYTHING. The browser decides what is worth SHOWING; the
// server decides what may be REACHED, in its one mount table, on every request. If these
// two ever disagree the server wins and the user sees a 403 — which is the correct
// failure and the right way round. A role read from a payload is a display hint, and
// treating it as a permission is how a client-side check becomes a security model.
export const ROLE = { PARTNER: 'partner', SECRETARY: 'secretary', LIMITED: 'limited' };

export const ROLES = Object.values(ROLE);

// Everyone who works IN the system. The ordinary audience for a screen, and deliberately
// not "everyone who can log in" — a content writer is not staff, they are an uploader.
export const STAFF = [ROLE.PARTNER, ROLE.SECRETARY];

export const isPartner = (user) => !!user && user.role === ROLE.PARTNER;
export const isLimited = (user) => !!user && user.role === ROLE.LIMITED;
